import { rm } from 'utils';
import {
  BaseFormAction,
  emailRule,
  phoneRule,
  BaseFormState
} from 'components/CustomerSupportForms/Utils';
import InputWithRules from 'components/Input/Input';
import { ChangeContactInfoEnum } from 'models/ChangeContactInfoEnum';
import { isValidEmail } from 'components/Shared/Form';
import { isValidPhoneNumber } from 'views/CheckoutPage/validation';

export const getContactOptions = () => [
  {
    id: 'contactOptionEmail',
    value: rm('customerService_form_contact_option_email'),
    label: rm('customerService_form_contact_option_email')
  },
  {
    id: 'contactOptionPhone',
    value: rm('customerService_form_contact_option_phone'),
    label: rm('customerService_form_contact_option_phone')
  }
];

type GetInputFieldWithRulesProps = {
  option: string;
  input: string;
  setInput: (val: string) => void;
  setChecked: (val: number) => void;
};

export const getInputFieldWithRules = ({
  option,
  input,
  setInput,
  setChecked
}: GetInputFieldWithRulesProps) => {
  if (option === rm('customerService_form_contact_option_phone')) {
    return (
      <InputWithRules
        change={e => setInput(e.target.value)}
        value={input}
        type="tel"
        rule={phoneRule}
        placeholder={rm('Customerservice_Form_Product_Contact_Phone')}
        inputMode="tel"
        focus={() => setChecked(ChangeContactInfoEnum.InputNewContact)}
      />
    );
  }

  return (
    <InputWithRules
      change={e => setInput(e.target.value)}
      value={input}
      type="email"
      rule={emailRule}
      placeholder={rm('Customerservice_Form_Product_Contact_Email')}
      focus={() => setChecked(ChangeContactInfoEnum.InputNewContact)}
    />
  );
};

type IsCustomerContactValidProps = {
  state: BaseFormState;
  valid: boolean;
  dispatch: (action: BaseFormAction) => void;
};

export const isCustomerContactValid = ({ state, valid, dispatch }: IsCustomerContactValidProps) => {
  const { contactOption } = state;
  if (contactOption.preferredContactMethod === '') {
    dispatch({
      type: 'contactOptionError',
      value: rm('customerService_form_contact_error')
    });
    return false;
  }
  if (contactOption.changeContactInfo === ChangeContactInfoEnum.InputNewContact) {
    if (contactOption.newContactInfo === '') {
      dispatch({
        type: 'contactOptionError',
        value: rm('customerService_form_contact_error')
      });
      return false;
    }

    const isEmail =
      contactOption.preferredContactMethod === rm('customerService_form_contact_option_email');
    const isValidContactInfo = isEmail
      ? isValidEmail(contactOption.newContactInfo)
      : isValidPhoneNumber(contactOption.newContactInfo);

    if (!isValidContactInfo) {
      dispatch({ type: 'contactOptionError', value: rm('customerService_form_contact_error') });
      return false;
    }
  }
  return valid;
};
